module.exports = __webpack_public_path__ + "media/images/kantar/metaskope_logo-cf4355119b051440b28323c1693187f0.png";